import { render } from "./widget-indicator.vue?vue&type=template&id=fd29a9e2&ts=true"
import script from "./widget-indicator.ts?vue&type=script&lang=ts"
export * from "./widget-indicator.ts?vue&type=script&lang=ts"

import "./widget-indicator.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/builds/elichens-avolta-connect/software/avolta-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__